<template>
  <div>
    <v-select :filterable="false" @search="fetchOptions" v-model="selected" :options="options"
      :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { axiosMixin } from "@/mixin/axiosMixin.js";
export default {
  mixins: [axiosMixin],
  data() {
    return {
      options: [
      ],
      selected: {},
    }
  },
  props: {
    endPoint: {
      type: String,
      default: null,
    },
    tableParams: {
      type: Object,
      default: null,
    },
    defaultValue: {
      type: String,
      default: null,
    },
  },
  watch: {
    selected(value) {
      this.$emit('input', value);
    },
  },
  components: {
    'v-select': vSelect,
  },
  mounted() {
    var params = "page1&per_page=10";
    var sort = "&sort_by=id&sort_direction=asc";
    const searchData = { searchValue: "all" };
    const payload = Object.assign({}, this.tableParams, searchData);

    console.log("payload:", payload);
    this.aronPost(this.endPoint, payload, params, sort)
      .then(response => {
        if (response.status == 200) {
          this.options = response.data.options;
          this.selected = this.findObjectById(this.defaultValue);
        }

      })
      .catch(error => {
      });
  },
  methods: {
    findObjectById(searchItem) {
      if (typeof searchItem === 'object' && searchItem !== null) {
        return this.options.find(item => item.id == searchItem.id);
      } else {
        return this.options.find(item => item.id == searchItem);
      }
    },
    fetchOptions(search, loading) {
      loading(true)
      // fetch data from server
      var params = "page1&per_page=10";
      var sort = "&sort_by=id&sort_direction=asc";
      if (search == '') search = "all";
      const searchData = { searchValue: search };
      const payload = Object.assign({}, this.tableParams, searchData);

      this.aronPost(this.endPoint, payload, params, sort)
        .then(response => {
          if (response.status == 200) {
            this.options = response.data.options;
          }

          loading(false)
        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
          loading(false)
        });
    }
  }
}
</script>
